<template id="video-template">
  <video class="w-full h-full" controls v-if="src.includes('.mp4')">
    <source :src="src" type="video/mp4" />
  </video>
  <img
    :src="src"
    alt=""
    class="advertisements__item__media"
    v-if="
      src.includes('.png') ||
        src.includes('.jpg') ||
        src.includes('.jpeg') ||
        src.includes('.jepg')
    "
  />
</template>
<script>
export default {
  props: ["src"],
};
</script>
